import { Injectable, EventEmitter } from '@angular/core';
import { AlertController, LoadingController, ToastController, NavController, Platform } from '@ionic/angular';
import { ActionlistenService } from '../actionlisten.service';
import { CommonDeclarationService } from './common-declaration.service';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { Device } from '@ionic-native/device/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import * as moment from 'moment';
import { Router } from '@angular/router';

declare var window: any;
declare var navigator: any;




@Injectable({
  providedIn: 'root'
})
export class CommonDefinitionService {

  loaderVal: any
  greetingupdate: any;
  greetingmessage: any;
  greetingmessage1: any;
  updateV: any;
  betaV: any;
  currentV: any;
  MaintenanceRequired: any;
  BackenablePages: any;
  Backtowhere: any;
  DisplayLoader: any;
  setUserInfo: any;
  preRegisterData: any;
  userType: any;
  profileName: any;
  setUserData: any;
  previousPage: any;
  newPreviousPage: any;
  detailsPageScreenshot: any;
  consentPageScreenshot: any;
  visitedPage: any;
  selectedVAS: any;
  vasNewEmailId: any;
  vasNewMobileNumber: any;
  emailScreenRedirection: any;
  mobileScreenRedirection: any;
  popover: any;
  headerType: any;
  AppandroidUrl: any;
  AppiosUrl: any;
  logoutFlg: any;
  addressparams: any;
  alertrestiction: any = true;
  TrakcerForm: any;
  TrakcerFromValue: any;
  freealert: any;
  notificationNumber: any;

  pushEvent: EventEmitter<any> = new EventEmitter();


  constructor(public Toast: ToastController, public screenOrientation: ScreenOrientation, public device: Device, public datepicker: DatePicker, public platform: Platform, public actionVal: ActionlistenService, public navCtrl: NavController, public alertctrl: AlertController, public loader: LoadingController, public toast: ToastController, public cmndecl: CommonDeclarationService, public router: Router) {
    this.AppandroidUrl = 'https://play.google.com/store/apps/details?id=com.pmli.fusion&hl=en';
    this.AppiosUrl = 'https://apps.apple.com/us/app/khushi/id1483018010';

    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        console.log(this.screenOrientation.type);
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
        this.screenOrientation.onChange().subscribe(
          () => {
            console.log("Orientation Changed");
          }
        );
      }
    });
    this.settingBackConfig()
  }

  settingBackConfig() {

    this.TrakcerForm = ["/documentdownload","/va/addressForm","/va/nomineeForm", "/va/mobileupdate", "/va/updatemobile", "/va/emailupdate", "/va/updateemail","/bankform", "/va/aadharForm","/va/changefrequency","/va/updateappointee","/va/changedob","/va/updatename","/va/linkpolicy", "/va/youtubevideo","/va/dlc"];
    this.BackenablePages = ['/login', '/existingCustomer', "/verifyemailOtpupdate", "/verifyOtpupdate", "/documentdownload", "/prospregister", "/changePassword", "/va/faqs", "/va/nomineeForm", "/va/mobileupdate", "/va/updatemobile", "/va/emailupdate", "/va/updateemail", "/changelanguage", "/about", "/starred", "/va/setting", "/profile", "/va/emailchat", "/prospectuser", "/forgotpassword", "/bankform", "/va/aadharForm", "/va/panForm", "/verifyOtp", "/forgotChangePassword", "/verifyOtpPassword", "/va/addressForm", "/verifyOtpaddress", "/verifyOtpReg", "/va/changefrequency","/va/changedob","/va/updateappointee","/va/updatename","/verifyotppros","/va/notification","/verifyOtpVa","/claim","/va/linkpolicy","/va/linkpolicy","/claimlogin","/va/youtubevideo","/va/dlc","/va/vasdetails", "/va/consentpage", "/va/vasfaq"];
    
    
    this.TrakcerFromValue = {
      "/bankform": "bankform",
      "/va/emailupdate": "emailform_otp",
      "/va/updateemail": "emailform_proof",
      "/va/mobileupdate": "mobileform_otp",
      "/va/updatemobile": "mobileform_proof",
      "/va/aadharForm": "aadharform",
      "/va/addressForm": "addressform",
      "/va/nomineeForm": "nomineeform",
      "/va/panForm": "panform",
      "/documentdownload": "documentdownload",
      "/va/changefrequency": "changefrequency",
      "/va/updateappointee":"updateappointee",
      "/va/changedob": "changedob",
      "/va/updatename": "updatename",
      "/va/linkpolicy": "LinkMyPolicy",
      "/va/youtubevideo": "youtube_video",
      "/va/dlc": "Digital_dertificate"
    };

    this.Backtowhere = {
      "/login": "/preRegister",
      "/va/faqs": "/va/chat",
      "/changelanguage": "/va/chat",
      "/changePassword": "/verifyOtpPassword",
      "/about": "/va/chat",
      "/starred": "/va/chat",
      "/va/setting": "/va/chat",
      "/profile": "/va/chat",
      "/va/emailchat": "/va/chat",
      "/existingCustomer": "/preRegister",
      "/prospectuser": "/preRegister",
      "/forgotpassword": "/login",
      "/forgotChangePassword": "/verifyOtp",
      "/bankform": "/va/chat",
      "/va/emailupdate": "/va/chat",
      "/va/updateemail": "/va/chat",
      "/va/mobileupdate": "/va/chat",
      "/va/updatemobile": "/va/chat",
      "/va/aadharForm": "/va/chat",
      "/va/addressForm": "/va/chat",
      "/va/nomineeForm": "/va/chat",
      "/va/panForm": "/va/chat",
      "/verifyOtp": "/forgotpassword",
      "/verifyOtpPassword": "/va/chat",
      "/prospregister": "/va/chat",
      "/verifyOtpaddress": "/va/addressForm",
      "/documentdownload": "/va/chat",
      "/verifyOtpReg": "/existingCustomer",
      "/verifyemailOtpupdate": "/va/emailupdate",
      "/verifyOtpupdate": "/va/mobileupdate",
      "/va/changefrequency":"/va/chat",
      "/va/changedob" :"/va/chat",
      "/va/updateappointee":"/va/chat",
      "/va/linkpolicy":"/va/chat",
       "/va/updatename": "/va/chat",
       "/verifyotppros": "/prospectuser",
       "/va/notification": "/va/chat",
       "/verifyOtpVa" : "/prospregister",
       "/claim" : "/preRegister",
       "/claimlogin": "/va/chat" ,
       "/va/youtubevideo": "/va/chat",
       "/va/dlc": "/va/chat",
       "/va/vasdetails": "/va/chat",
       "/va/consentpage": "/va/vasdetails"
    }
    this.DisplayLoader = ["getLanguageDetails", "getNomineeDetails", "verifyPincode", "emailChat", "otpRequest", "otpRequest", "loginAuthentication", "userRegistration", "verifyPincode", "getFAQList", "starredMessage"];
  }

  async loaderstart() {
    this.cmndecl.loaderenable = true;
  }

  async loaderend() {
    this.cmndecl.loaderenable = false;
  }

  async presentAlert(headr, msg, type) {
    console.log(this.alertrestiction)
    let okmsg;
    if (type == "otperror") {
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    } else if (type == "downlddoc") {
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    } else if (type == 'error') {
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    }else if(type == 'doberror'){
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    } else if(type == 'nomineeerror'){
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    }else if(type == 'appointeerror'){
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
      this.alertrestiction = true;
    } else if(type == 'Failed' || type == 'Failure'){
      okmsg = 'OK';
      this.alertrestiction = true;
    }else {
      this.alertrestiction = true;
      okmsg = this.cmndecl.LanguageJson.pages[0].alerts.ok;
    }
    if (this.alertrestiction) {
      this.alertrestiction = false;
      const alert = await this.alertctrl.create({
        header: headr,
        subHeader: "",
        message: msg,
        backdropDismiss: false,
        buttons: [
          {
            text: okmsg,
            handler: (blah) => {
              this.alertrestiction = true;
              if (type == "Maintenance") {
                console.log('Confirm Cancel: blah');
                this.alertrestiction = true;
                navigator['app'].exitApp();
              } else if (type == "expired") {
                this.cmndecl.functionCall="logout";
                this.cmndecl.parampassing = "auto";
                this.alertrestiction = true;
              } else if (type == 'registersuccess') {
                this.alertrestiction = true;
                sessionStorage.CurrentPage = "/loginUnregister";
                this.navCtrl.navigateRoot("/loginUnregister")
              }
              else if (msg.includes("Registration unsuccessful") == true) {
                this.alertrestiction = true;
                sessionStorage.CurrentPage = "/existingCustomer";
                this.navCtrl.navigateRoot("/existingCustomer")
              }
              else if (type == 'forgotpwdsuccess') {
                this.alertrestiction = true;
                localStorage.removeItem("forgotPasswordData");
                sessionStorage.CurrentPage = "/login";
                this.navCtrl.navigateRoot("/login")
              }
              else if (type == 'forgotpwdfailure') {
                this.alertrestiction = true;
                localStorage.removeItem("forgotPasswordData");
                sessionStorage.CurrentPage = "/forgotpassword";
                this.navCtrl.navigateRoot("/forgotpassword")
              } else if (type == 'info') {
                this.alertrestiction = true;
              } else if(type == "changeEmail") {
                this.alertrestiction = true;
                this.navCtrl.navigateRoot("/va/emailupdate");
              } else if(type == "changeMobile") {
                this.alertrestiction = true;
                this.navCtrl.navigateRoot("/va/mobileupdate");
              }
            }
          }
        ]
      });
      await alert.present();
    }

  }


  async showConfirmAlert(headr, msg, type, btn1, btn2) {
    let data: any;
    if (this.alertrestiction) {
      this.alertrestiction = false;
      const alert = await this.alertctrl.create({
        header: headr,
        subHeader: "",
        message: msg,
        backdropDismiss: false,
        buttons: [
          {
            text: btn1,
            cssClass: "yesbutton",
            handler: (blah) => {
              this.alertrestiction = true;
              if (type == "logout") {
                this.logoutFlg = 0;
                this.logoutsession();
              } else if (type == 'previouschat') {
                this.cmndecl.functionCall='newchat';
              } else if (type == 'clearchat') {
                this.cmndecl.functionCall='clearchat';
              } else if (type == "exit") {
                this.cmndecl.functionCall="logout";
                this.cmndecl.parampassing = "auto";
              } else if (type == "close") {
                navigator['app'].exitApp();
              } else if (type == 'emailupdate') {
                this.cmndecl.functionCall="email";
                this.cmndecl.parampassing = this.cmndecl.LanguageJson['pages'][0].alerts.emailques;
                sessionStorage.CurrentPage = "/va/chat";
                this.navCtrl.navigateForward("/va/chat");
              } else if (type == 'customercare') {
                data = "tel:" + this.cmndecl.LanguageJson['pages'][0].vaAssistant.contactNumber;
                window.open(data);
                this.updatechatcall();
              } else if (type == 'rateus') {
                if (this.cmndecl.runPlatform == "android")
                  window.open(this.AppandroidUrl, '_system');
                else if (this.cmndecl.runPlatform == "ios")
                  window.open(this.AppiosUrl, '_system');
              } else if (type == 'prospectLogin') {
                localStorage.removeItem("user");
                localStorage.removeItem("dobdate");
                localStorage.removeItem("logined");
                localStorage.removeItem("role");
                localStorage.removeItem("dob");
                this.cmndecl.deleteProcess("profile");
                localStorage.removeItem("logout");
                this.cmndecl.deletefile();
                this.cmndecl.ChatFullHistory=[];
                this.cmndecl.ChatfullList =[];
                this.cmndecl.capsuleList = [];
                localStorage.removeItem("uniqueId");
                localStorage.removeItem("userChatSessionId");
                localStorage.removeItem("userSessionID");
                localStorage.removeItem("tackbackenable");
                localStorage.removeItem('nothanks');
                localStorage.removeItem('banner');
                localStorage.removeItem("voiceenable")
                this.cmndecl.functionCall="proslogut";
                this.cmndecl.parampassing = "proslogut";
              } else if (type == 'reminder') {
                this.logoutFlg = 0;
                this.cmndecl.functionCall="deletereminder";
              }
            }
          },
          {
            text: btn2,
            cssClass: 'secondary',
            handler: (blah) => {
              this.alertrestiction = true;
              if (type == 'emailupdate') {
                sessionStorage.CurrentPage = "/va/chat";
                this.navCtrl.navigateRoot("/va/chat");
              }
              console.log("cancel clicked")
            }
          }
        ]
      });
      await alert.present();
    }
  }



  async showdatePicker(selectedDate: any, minDte: any, maxDate: any) {
    let version = Number(this.device.version);
    let resolveDate: any;
    let options: any;
    return new Promise((resolve, reject) => {
      if (this.device.platform == "Android") {
        if (version < 8) {
          this.datepicker.show({
            date: selectedDate,
            mode: 'date',
            androidTheme: 5,
            okText: "Done",
            maxDate: new Date(maxDate).valueOf(),
            minDate: new Date(minDte).valueOf()
          }).then(
            date => {
              console.log(date);
              resolve(moment(new Date(date)).format('DD/MM/YYYY'));
            },
            err => {
              reject(err);
              console.log('Error occurred while getting date: ', err)
            }
          );
        } else {
          this.datepicker.show({
            date: selectedDate,
            mode: 'date',
            androidTheme: this.datepicker.ANDROID_THEMES.THEME_HOLO_LIGHT,
            okText: "Done",
            maxDate: new Date(maxDate).valueOf(),
            minDate: new Date(minDte).valueOf()
          }).then(
            date => {
              console.log(date);
              resolve(moment(new Date(date)).format('DD/MM/YYYY'));
            },
            err => {
              console.log('Error occurred while getting date: ', err);
            }
          );
        }
      } else {
        if (maxDate == "" || maxDate == undefined) {
          maxDate = new Date();
        }

        if (minDte == "" || minDte == undefined) {
          options = {
            date: selectedDate,
            mode: 'date',
            doneButtonLabel: "Done",
            cancelButtonLabel: "Cancel",
            allowFutureDates: false,
            maxDate: new Date(maxDate).valueOf()
          }
        } else {
          options = {
            date: selectedDate,
            mode: 'date',
            doneButtonLabel: "Done",
            cancelButtonLabel: "Cancel",
            allowFutureDates: false,
            maxDate: new Date(maxDate).valueOf(),
            minDate: new Date(minDte).valueOf()
          }
        }

        this.datepicker.show(options).then(
          date => {
            console.log(date);
            resolveDate = moment(new Date(date)).format('DD/MM/YYYY');
            if (resolveDate == "Invalid date")
              resolve("");
            else
              resolve(resolveDate);
          },
          err => {
            reject(err);
            console.log('Error occurred while getting date: ', err)
          }
        );
      }
    });
  }

  async  Showtoast(msg: any) {
    const toast = await this.toast.create({
      message: msg,
      duration: 2000,
    });
    toast.present();
  }

  async updatechatcall() {
    console.log("Its called");
    this.cmndecl.functionCall="updatecall";
  }
  async logoutsession() {
    console.log("Its called");
    this.cmndecl.functionCall= "logout";
    this.cmndecl.parampassing = "manual";
  }

  // For Browser Build

  readThis(inputValue: any) {
    return new Promise(resolve => {
      var file: File = inputValue.files[0];
      var myReader: FileReader = new FileReader();
      myReader.onloadend = (e) => {
        resolve(myReader.result);
      }
      myReader.readAsDataURL(file);
    })

  }

}

